export enum PurchaseFlowSteps {
  Tile,
  ChooseImage,
  EditImage,
}

export const PageTitles: Array<string> = [
  'Buy Your Own Tile',
  'Pick your NFT Art',
  'Edit your NFT Art',
];
